<template>
  <div class="highlight highlight-container">
    <div
      id="highlight"
      class="page-highlight-part content-part-wrapper"
    >
      <div class="hightlight-title-wrapper content-title-wrapper">
        <h3>{{ $t('HIGHLIGHT')}}</h3>
        <span class="title-line"></span>
      </div>
      <div class="page-highlight-wrapper">
        <div class="hightlight-item-wrapper network-part">
          <img
            class="pc-img"
            src="../../assets/pagehighlight/highlight2.png"
          />
          <img
            class="mobile-img"
            data-src=""
          />
        </div>
        <div class="introduce">{{ $t('HIGHLIGHT_ONE')}}</div>
        <div class="hightlight-item-wrapper percent-part">
          <img
            class="pc-img"
            src="../../assets/pagehighlight/highlight3.png"
          />
          <img
            class="mobile-img"
            data-src=""
          />
        </div>
        <div class="introduce">{{ $t('HIGHLIGHT_TWO')}}</div>
        <div class="hightlight-item-wrapper storage-part">
          <img
            class="pc-img"
            src="../../assets/pagehighlight/highlight1_v2.png"
          />
          <img
            class="mobile-img"
            data-src=""
          />
        </div>
        <div class="introduce">{{ $t('HIGHLIGHT_THREE')}}</div>
        <div class="hightlight-item-wrapper platform-part">
          <img
            class="pc-img"
            src="../../assets/pagehighlight/highlight4.png"
          />
          <img
            class="mobile-img"
            data-src=""
          />
        </div>
        <div class="introduce">{{ $t('HIGHLIGHT_FOUR')}}</div>
      </div>
    </div>`
  </div>
</template>

<i18n>
{
  "en": {
    "HIGHLIGHT": "HIGHLIGHT",
    "HIGHLIGHT_ONE": "BonusCloud develops an exclusive encrypted network on the basis of Kademlia network, also can be divided and aggregated based on features of the user’s basic network.",
    "HIGHLIGHT_TWO": "BonusCloud provides community with different kinds of computing environments, so as to meet the requirements of different developers.",
    "HIGHLIGHT_THREE": "Different workers in BonusCloud will be allocated to support different scenarios according to their different storage and bandwidth capabilities.",
    "HIGHLIGHT_FOUR": "BonusCloud provides customers with an open and trustworthy environment to conduct valuable exchange of computing capability."
  },
  "zn": {
    "HIGHLIGHT": "亮点",
    "HIGHLIGHT_ONE": "博纳云开发基于Kademlia网络的专用加密网络，也可以根据用户基本网络特点进行划分与聚合。",
    "HIGHLIGHT_TWO": "博纳云为社区提供了不同类型的计算环境，以满足各开发人员的不同需求。",
    "HIGHLIGHT_THREE": "根据博纳云将不同的存储及带宽能力分配给不同工作者来支持不同的场景。",
    "HIGHLIGHT_FOUR": "博纳云为客户实现有价值的计算能力交换提供了一个开放且值得信赖的环境。"
  }
}
</i18n>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "PcLogin",
  props: {},
  data() {
    return {};
  },
  computed: mapState({
    isZnWebsite: state => state.isZnWebsite,
  }),
  methods: {
    ...mapActions([]),
    changeLanguage() {}
  },
  created() {
    //  let language = this.$cookie.get('BASIC_LANUAGE');
    // this.$i18n.locale = language;
    // this.whichLanguage = (language === 'zn');
    this.$i18n.locale = this.isZnWebsite ? "zn" : "en";
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.page-highlight-part {
  margin-bottom: 80px;

  .hightlight-item-wrapper {
    width: 70%;
    padding: 60px 0;
    margin: 0 auto;

    // margin-bottom: 80px;
    &.storage-part {
      // max-width: 800px;
      max-width: 50%;
      // background: url(../../assets/pagehighlight/hightlight1.png);
    }

    &.network-part {
      max-width: 50%;
      // background: url(../../assets/pagehighlight/hightlight2.png);
    }

    &.percent-part {
      max-width: 50%;
      // background: url(../../assets/pagehighlight/hightlight3.png);
    }

    &.platform-part {
      max-width: 50%;
      // background: url(../../assets/pagehighlight/hightlight4.png);
    }

    img {
      display: block;
      width: 100%;
      // -webkit-filter: grayscale(70%);
      // filter: grayscale(70%);
    }
  }

  .introduce {
    width: 60%;
    text-align: center;
    // padding: 60px 0;
    padding-bottom: 60px;
    margin: 0 auto;
    font-size: 13px;
    line-height: 2;
    letter-spacing: 1.3px;
  }
}

@media (max-width: 720px) {
  .page-highlight-part {
    margin-bottom: 40px;

    .hightlight-item-wrapper {
      width: 90%;
      margin-bottom: 20px;
      padding: 40px 0 20px;

      &.platform-part {
        width: 95%;
      }

      &.storage-part {
        // max-width: 800px;
        max-width: 95%;
        // background: url(../../assets/pagehighlight/hightlight1.png);
      }

      &.network-part {
        max-width: 95%;
        // background: url(../../assets/pagehighlight/hightlight2.png);
      }

      &.percent-part {
        max-width: 95%;
        // background: url(../../assets/pagehighlight/hightlight3.png);
      }

      &.platform-part {
        max-width: 95%;
        // background: url(../../assets/pagehighlight/hightlight4.png);
      }
    }

    .introduce {
      width: 100%;
    }
  }
}
</style>
